const BGColor = color => {
  switch(color) {
    case 'blue':
      return `
        color: #fff;
        background-color: #3366ff;`;
    
    case 'sky-blue':
      return `
        color: #fff;
        background-color: #32cbff;
      `
    case 'yellow':
      return `
        color: #000;
        background-color: yellow;`;
    
    case 'green':
      return `
        color: #fff;
        background-color: #527D5A;`;

    case 'red':
      return `
        color: #fff;
        background-color: #ee4035;`;

    case 'orange':
      return `
        color: #fff;
        background-color: #f0ad4e;`;

    case 'dark-gray':
      return `
        color: #fff;
        background-color: #262626;
      `

    case 'gray':
      return `
        color: #fff;
        background-color: #7B7E8B;
      `

    case 'purple':
      return `
        color: #fff;
        background-color: #AD1E90;
      `
    
    case 'brown':
      return `
        color: #fff;
        background-color: #8b5742;
      `

    case 'general':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #fea85b;
      `

    case 'simple':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #46d7d9;
      `

    case 'dme':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #3183ff;
      `

    case 'dvd':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #1c62cc;
      `

    case 'jeju':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #2ba5a6;
      `
    case 'main':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #fb76a2;
      `

    case 'remind':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #48a7e4;
      `

    case 'family':
      return `
        color: #fff;
        font-weight: 700;
        background-color: #8dd088;
      `

    default:
      return `
        color: #fff;
        background-color: #2074c8;`;
  }
}

export default BGColor;


// WEBPACK FOOTER //
// ./client/components/Styled/Tag/BGColor.js